import { Injectable } from '@angular/core';
import { MapPane, MapPaneIndex } from '@common/enums';
import { LocalAuthority } from '@modules/local-authorities/interfaces';
import { polygonToLine } from '@turf/turf';
import { FeatureGroup, geoJSON, Layer, Map } from 'leaflet';

@Injectable({
    providedIn: 'root'
})
export class PlotLocalAuthoritiesService {
    constructor() {}

    public plotLocalAuthorities(map: Map, localAuthority: any[]): void {
        if (!map.getPane(MapPane.LOCAL_AUTHORITIES)) map.createPane(MapPane.LOCAL_AUTHORITIES);

        this.removeDataFromLaPane(map);

        for (const element of localAuthority) {
            geoJSON(element, { pane: MapPane.LOCAL_AUTHORITIES, pmIgnore: true })
                .addTo(map)
                .eachLayer((layer: Layer) => {
                    const geojson: FeatureGroup = layer as FeatureGroup;

                    geojson.setStyle({
                        color: '#808080',
                        opacity: 0.9,
                        fillColor: '#808080',
                        fillOpacity: 0
                    });
                });
        }

        map.getPane(MapPane.LOCAL_AUTHORITIES)!.style.zIndex = MapPaneIndex.LOCAL_AUTHORITIES;
    }

    private removeDataFromLaPane(map: Map): void {
        map.eachLayer((layer: Layer) => {
            if (layer.options.pane === MapPane.LOCAL_AUTHORITIES) map.removeLayer(layer);
        });
    }
}
